import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { HorarioLaboral } from "src/app/shared/model/tarea/horario-laboral.model";
import { EmpleadoHorario } from "src/app/shared/model/tarea/empleado-horario.model";
import { JornadaLaboral } from "src/app/shared/model/tarea/jornada-laboral.model";
import { sinSelloDeError } from "src/app/shared/http/sello-de-error";

@Injectable({
  providedIn: "root",
})
export class HorarioLaboralService {
  constructor(private http: HttpClient) {}

  consultarHorarios(filtro: HorarioLaboral | null): Observable<ConsultaList<HorarioLaboral>> {
    const request = new ConsultaList<HorarioLaboral>();
    request.bean = filtro;
    return this.http.post<ConsultaList<HorarioLaboral>>(UrlConstantes.CONSULTA_HORARIOS_LABORALES, request);
  }

  obtenerHorario(id: number): Observable<HorarioLaboral> {
    const request = new HorarioLaboral();
    request.id = id;
    return this.http.post<HorarioLaboral>(UrlConstantes.DETALLE_HORARIO_LABORAL, request);
  }

  /**
   * Un rechazo del servidor (nombre, días, horas, comidas, tolerancia) no
   * viene en el cuerpo: llega como 200 vacío con el motivo en la cabecera
   * MESSAGE. Sin sinSelloDeError el editor recibía null y mostraba un
   * error en blanco; así sale por `error:` con el texto del servidor.
   */
  guardarHorario(horario: HorarioLaboral): Observable<HorarioLaboral> {
    return this.http
      .post<HorarioLaboral>(UrlConstantes.GUARDAR_HORARIO_LABORAL, horario, { observe: "response" })
      .pipe(sinSelloDeError<HorarioLaboral>("No se pudo guardar el horario."));
  }

  asignarHorario(asignacion: EmpleadoHorario): Observable<EmpleadoHorario> {
    return this.http.post<EmpleadoHorario>(UrlConstantes.ASIGNAR_HORARIO_EMPLEADO, asignacion);
  }

  consultarAsignaciones(idEmpleado: number): Observable<ConsultaList<EmpleadoHorario>> {
    const request = new ConsultaList<EmpleadoHorario>();
    const bean = new EmpleadoHorario();
    bean.idEmpleado = idEmpleado;
    request.bean = bean;
    return this.http.post<ConsultaList<EmpleadoHorario>>(UrlConstantes.CONSULTA_ASIGNACIONES_HORARIO_EMPLEADO, request);
  }

  consultarJornada(filtro: JornadaLaboral): Observable<JornadaLaboral> {
    return this.http.post<JornadaLaboral>(UrlConstantes.CONSULTA_JORNADA_HORARIO_EMPLEADO, filtro);
  }
}
